import React from "react";
import { useNavigate } from "react-router-dom";

function BackButton({ to = "/", label = "Back", className = "" }) {
  const navigate = useNavigate();
  const canGoBack = typeof window !== "undefined" && window.history.length > 1;

  return (
    <button
      type="button"
      onClick={() => (canGoBack ? navigate(-1) : navigate(to))}
      className={[
        "inline-flex items-center justify-center gap-2 rounded-full border border-[#E6EAF0] bg-white px-3 py-2 text-[16px] font-semibold text-slate-700 shadow-sm",
        className,
      ].join(" ")}
    >
      <span className="leading-none">{label}</span>
    </button>
  );
}

export default BackButton;

